
const constants = {

    
    MW3NewViewOrderURL : '/store/NewViewOrder.do',
    localHost : 'localhost:8082',
    MW3NewPurchase : '/store/NewPurchase.do',
    OrderURL: '/store/SWNewlicenseOrder.do',
    MonthlyLicenseAmount: 9.95,
    OneYearLicenseAmount: 99.95,
    TwoYearLicenseAmount: 149.95,
    CancelReasonURL: '/store/CancelReason.do',
    UpdateRecurringUserInfo: '/store/UpdateRecurringUserInfo.do',
    CancelReasonMessage: '/store/CancelReasonMessage.do',
    UpdateRecurringUserInfoMessage: '/store/UpdateRecurringUserInfoMessage.do',
    licensepromotion1New: '/store/licensepromotion1New.do',

    MW3OneYearSWlicenseOrder: "/store/DiscountOneYearSWNewlicenseOrder.do?",
    MW3TwoYearSWlicenseOrder: "/store/DiscountTwoYearSWNewlicenseOrder.do?",
    MW3OneYearCWlicenseOrder: "/store/DiscountOneYearCWNewlicenseOrder.do?",
    MW3TwoYearCWlicenseOrder: "/store/DiscountTwoYearCWNewlicenseOrder.do?",
    MW3OnePlusOneYearSWlicenseOrder: "/store/store/MW3OnePlusOneYearSWNewlicenseOrder.do?",
    MW3OnePlusOneYearCWlicenseOrder: "/store/store/MW3OnePlusOneYearCWNewlicenseOrder.do?",
    MW3_1YearFreeOn2YearSWlicenseOrder: "/store/store/MW3_1YearFreeOn2YearSWNewlicenseOrder.do?",
    MW3_1YearFreeOn2YearCWlicenseOrder: "/store/store/MW3_1YearFreeOn2YearCWNewlicenseOrder.do?",
    MW3RecurringComplimentarySWLicenseOrder: "/store/Discount1RecurringSWNewLicenseOrder.do?",
    MW3RecurringComplimentaryCWLicenseOrder: "/store/Discount1RecurringCWNewLicenseOrder.do?",
    MW3RecurringDiscountSWNewLicenseOrder: "/store/DiscountRecurringSWNewLicenseOrder.do?",
    MW3RecurringDiscountCWNewLicenseOrder: "/store/DiscountRecurringCWNewLicenseOrder.do?"
}

export default constants